import { createSlot } from "lib/@components/slot/create-slot"

// Actions rendered on the read-only view of a component-library task (e.g. the Find Similar button).
export const MaintenanceTaskActions = createSlot("MaintenanceTaskActions")

// Banner area above the read-only task view (e.g. the incomplete-component warning).
export const MaintenanceTaskBanner = createSlot("MaintenanceTaskBanner")
